import script from "./Dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Dropdown.vue?vue&type=script&setup=true&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=7865ce3d&scoped=true&lang=scss"

import exportComponent from "/Users/ilvinipitter/code/lider-fornecedores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7865ce3d"]])

export default __exports__